import React from 'react';
import { Icon } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { TbSparkles } from 'react-icons/tb';

/**
 * In-chat waiting indicator: the Carl sparkle gently pulsing and rocking.
 * Used wherever a turn is running inside a chat thread (thinking bubble,
 * drawer "working" row, tool-step timeline) — the 3D CarlLogo is reserved
 * for hero/branding spots.
 */

const sparklePulse = keyframes`
    0%, 100% { transform: scale(1) rotate(-8deg); opacity: 0.75; }
    50% { transform: scale(1.18) rotate(8deg); opacity: 1; }
`;

const CarlThinkingSparkle = ({ size = '18px' }: { size?: string }) => (
    <Icon
        as={TbSparkles as React.ElementType}
        w={size}
        h={size}
        color="#0071E3"
        flexShrink={0}
        animation={`${sparklePulse} 1.3s ease-in-out infinite`}
    />
);

export default CarlThinkingSparkle;
